import { useQuery } from "@tanstack/react-query";
import { getSupabaseWithLogging } from "@/lib/hooks/api/utils";

export function useContactFiles(params?: {
  page?: number;
  limit?: number;
  search?: string;
  contact_id?: string;
  type?: string;
}) {
  return useQuery({
    queryKey: ["contact-files", params],
    queryFn: async () => {
      const supabase = getSupabaseWithLogging();
      let query = supabase.from("contact_files").select(`
                    *,
                    contacts:contact_id (
                        id,
                        name,
                        company_name,
                        email
                    ),
                    users:app_users!contact_files_user_id_fkey(
                        id,
                        first_name,
                        last_name,
                        email
                    )
                `);

      if (params?.contact_id) {
        query = query.eq("contact_id", params.contact_id);
      }
      if (params?.type) {
        query = query.eq("type", params.type);
      }
      if (params?.search) {
        query = query.or(`name.ilike.%${params.search}%,description.ilike.%${params.search}%`);
      }

      if (params?.limit) {
        const offset = (params.page || 0) * params.limit;
        query = query.range(offset, offset + params.limit - 1);
      }

      const { data, error } = await query.order("uploaded_at", { ascending: false });

      if (error) {
        console.error("Error fetching contact files:", error);
        throw new Error(error.message);
      }

      return data || [];
    },
    staleTime: 5 * 60 * 1000,
  });
}
